<template>
  <div>
      <section class="xlrclh" v-if="id >=0 && id <=9">
          <img class="top-img" :src="policyObj.topBg" alt="" />
          <div class="technological-process">
              <div class="zccl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title1.png" alt="" />
                  <div class="content">
                      <div class="title" style="
                                  font-weight: bold;
                                  font-size: 0.26rem;
                                  margin-top: 0.13rem;
                                  text-align: left;
                                  line-height: 1.5;
                              ">
                          <span class="cricle-tip"></span>
                          {{ policyObj.policyTips }}
                      </div>
                      <div class="des" v-for="(item, index) in policyObj.policyType" :key="index">
                        <div class="persona-bility-title">
                          <div>{{ item.policyTypeTip }}</div>
                          <div>{{ item.policyTypeTitle }}</div>
                        </div>
                        <div v-if="item.policyTypeAsk" class="policyTypeAsk">{{ item.policyTypeAsk }}</div>
                        <div style="padding-left: 0.16rem">
                          <div v-for="(ite, idx) in item.policyTypeList" :key="idx" :style="idx > 0 ? 'margin-top: 0.1rem' : ''">（{{ idx + 1}}）{{ ite }}</div>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="zccl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title2.png" alt="" />
                  <div class="content" style="background-color: #d4e0ff;">
                      <div class="title" style="
                                  font-weight: bold;
                                  font-size: 0.26rem;
                                  margin-top: 0.13rem;
                                  text-align: left;
                                  line-height: 1.5;
                                  padding-top: 0.2rem;
                              ">
                          <span class="cricle-tip"></span>
                          {{ policyObj.conditionTips }}
                      </div>
                      <div class="condition-box" v-for="(item, index) in policyObj.conditionList" :key="index">
                        <div class="condition-title">{{ item.title }}</div>
                        <div class="condition-item" v-for="(ite, idx) in item.items" :key="idx">{{ ite }}</div>
                      </div>
                  </div>
              </div>
              <div class="sxcl">
                <img class="top" src="./../assets/imgs/applyPolicy/title3.png" alt="" />
                <div class="policy-content-title">
                  <div class="policy-content-title-tip"></div>
                  <div class="policy-content-title-txt">{{ policyObj.policyContentTitle }}</div>
                </div>
                <div class="policy-content-box">
                  <div class="content policy-content" v-for="(item, index) in policyObj.policyContent" :key="index">{{ item }}</div>
                  <div class="policy-content-leader">认定的“柔性人才”资助金额由人才工作领导小组“一事一议”研究确定。</div>
                </div>
              </div>
              <div class="sxcl">
                <img class="top" src="./../assets/imgs/applyPolicy/title4.png" alt="" />
                <!-- <div class="content" style="font-weight: bold">{{ policyObj.applyPath }}</div> -->
                <div class="content" style="font-weight: bold">
                  <span>符合条件的人才可以自行登录四川天府新区智慧人才服务平台</span>
                  <span style="color: #2078ff; font-weight: 500;" @click="navWeb">（https://www.tfxqtalents.com:8001/web）</span>
                  <span>进行申请，或者在天府人才小程序-直管区人才支持政策版本进行申报</span>
                </div>
              </div>
              <div class="sxcl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title5.png" alt="" />
                  <div class="content" style="font-weight: bold">{{ policyObj.applyTime }}</div>
              </div>
              <div class="contact">
                  <img class="top" src="./../assets/imgs/applyPolicy/title6.png" alt="" />
                  <div class="content">
                      <div class="number">
                          <span class="label">政策咨询电话：</span>
                          <div>
                              <a href="tel:028-68773465">{{ policyObj.tel }}</a>
                          </div>
                      </div>
                      <div class="unit">
                          <span class="label">责任单位：</span>
                          {{ policyObj.company }}
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <section class="xlrclh" v-if="id >= 10 && id <= 11">
          <img class="top-img" :src="policyObj.topBg" alt="" />
          <div class="technological-process">
              <div class="zccl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title1.png" alt="" />
                  <div class="content">
                      <div class="title" style="
                                  font-weight: bold;
                                  font-size: 0.26rem;
                                  margin-top: 0.13rem;
                                  text-align: left;
                                  line-height: 2;
                              ">
                          <span class="cricle-tip"></span>
                          {{ policyObj.policyTips }}
                      </div>
                  </div>
              </div>
              <div class="zccl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title2.png" alt="" />
                  <div class="content" style="background-color: #d4e0ff;">
                      <div class="title" style="
                                  font-weight: bold;
                                  font-size: 0.26rem;
                                  margin-top: 0.13rem;
                                  text-align: left;
                                  line-height: 1.5;
                                  padding-top: 0.2rem;
                              ">
                          <span class="cricle-tip"></span>
                          {{ policyObj.conditionTips }}
                      </div>
                      <div class="condition-box" v-for="(item, index) in policyObj.conditionList" :key="index">
                        <div class="condition-title">{{ item.title }}</div>
                        <div class="condition-item" v-for="(ite, idx) in item.items" :key="idx">{{ ite }}</div>
                      </div>
                  </div>
              </div>
              <div class="zccl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title3.png" alt="" />
                  <div class="content" style="background-color: #d4e0ff;">
                      <div class="title" style="
                                  font-weight: bold;
                                  font-size: 0.26rem;
                                  margin-top: 0.13rem;
                                  text-align: left;
                                  line-height: 1.5;
                                  padding-top: 0.2rem;
                              ">
                          <span class="cricle-tip"></span>
                          {{ policyObj.policyContent }}
                      </div>
                  </div>
              </div>
              <div class="sxcl">
                <img class="top" src="./../assets/imgs/applyPolicy/title4.png" alt="" />
                <!-- <div class="content" style="font-weight: bold">{{ policyObj.applyPath }}</div> -->
                <div class="content" style="font-weight: bold">
                  <span>符合条件的人才可以自行登录四川天府新区智慧人才服务平台</span>
                  <span style="color: #2078ff; font-weight: 500;" @click="navWeb">（https://www.tfxqtalents.com:8001/web）</span>
                  <span>进行申请，或者在天府人才小程序-直管区人才支持政策版本进行申报</span>
                </div>
              </div>
              <div class="sxcl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title5.png" alt="" />
                  <div class="content" style="font-weight: bold">{{ policyObj.applyTime }}</div>
              </div>
              <div class="contact">
                  <img class="top" src="./../assets/imgs/applyPolicy/title6.png" alt="" />
                  <div class="content">
                      <div class="number">
                          <span class="label">政策咨询电话：</span>
                          <div>
                              <a href="tel:028-68773465">{{ policyObj.tel }}</a>
                          </div>
                      </div>
                      <div class="unit">
                          <span class="label">责任单位：</span>
                          {{ policyObj.company }}
                      </div>
                  </div>
              </div>
          </div>
      </section>
      <section class="xlrclh" v-if="id >= 12 && id <= 13">
          <img class="top-img" :src="policyObj.topBg" alt="" />
          <div class="technological-process">
              <div class="zccl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title1.png" alt="" />
                  <div class="content">
                      <div class="title" style="
                                  font-weight: bold;
                                  font-size: 0.26rem;
                                  margin-top: 0.13rem;
                                  text-align: left;
                                  line-height: 1.5;
                              ">
                          <span class="cricle-tip"></span>
                          {{ policyObj.policyTips }}
                      </div>
                  </div>
              </div>
              <div class="sxcl">
                <img class="top" src="./../assets/imgs/applyPolicy/title7.png" alt="" />
                <!-- <div class="content" style="font-weight: bold">{{ policyObj.applyPath }}</div> -->
                <div class="content" style="font-weight: bold">
                  <span>符合条件的人才可以自行登录四川天府新区智慧人才服务平台</span>
                  <span style="color: #2078ff; font-weight: 500;" @click="navWeb">（https://www.tfxqtalents.com:8001/web）</span>
                  <span>进行申请，或者在天府人才小程序-直管区人才支持政策版本进行申报</span>
                </div>
              </div>
              <div class="sxcl">
                  <img class="top" src="./../assets/imgs/applyPolicy/title8.png" alt="" />
                  <div class="content" style="font-weight: bold">{{ policyObj.applyTime }}</div>
              </div>
              <div class="contact">
                  <img class="top" src="./../assets/imgs/applyPolicy/title9.png" alt="" />
                  <div class="content">
                      <div class="number">
                          <span class="label">政策咨询电话：</span>
                          <div>
                              <a href="tel:028-68773465">{{ policyObj.tel }}</a>
                          </div>
                      </div>
                      <div class="unit">
                          <span class="label">责任单位：</span>
                          {{ policyObj.company }}
                      </div>
                  </div>
              </div>
          </div>
      </section>
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
      return {
        id: '',
        policyList: [
          {
            pageTitle: '科技创新类',
            topBg: require('./../assets/imgs/applyPolicy/kjcx.png'),
            policyTips: '在直管区内高校、科研院所、新型研发机构、科技型企业和高技术服务企业（机构）工作，或依托直管区用人单位开展科研工作，或其科研成果在直管区转化，或其科研工作具有重大创新、发展前景，或其拥有丰富的科研基础知识、从业经验的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '国家最高科学技术奖获得者;',
                  '诺贝尔奖、图灵奖、菲尔兹奖获得者；',
                  '中国科学院院士，中国工程院院士；',
                  '美国、俄罗斯、英国、德国、法国、日本、加拿大、澳大利亚国家最高学术权威机构院士；',
                  '国家高层次人才特殊支持计划杰出人才人选，国家海外高层次人才引进计划顶尖人才人选；',
                  '国家实验室主任、国家实验室学术委员会主任、国家实验室基地主任；',
                  '国家自然科学奖、国家技术发明奖、国家科学技术进步奖一等奖及以上获得者（第1位完成人）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '中国青年科技奖获得者;',
                  '国家杰出青年科学基金获得者；',
                  '国家优秀青年科学基金获得者；',
                  '国家军委科技委卓越青年科学基金获得者；',
                  '国家有突出贡献的中青年专家；',
                  '国家高层次人才特殊支持计划中除杰出人才之外的人选、国家海外高层次人才引进计划除顶尖人才之外的人选；',
                  '国家自然科学奖、国家技术发明奖、国家科学技术进步奖一等奖获得者（第2、3位完成人）、二等奖获得者（第1位完成人）；',
                  '中国专利金奖、中国外观设计金奖前2位完成人（须为专利发明人或设计人）；',
                  '国家重点实验室、国家产业创新中心、国家制造业创新中心、国家技术创新中心、国家工程研究中心、天府实验室主任；',
                  '享受国务院政府特殊津贴专家；',
                  '百千万人才工程国家级人选；',
                  '中科院“百人计划”A类入选者、率先行动“百人计划”学术帅才；',
                  '相当于上述层次的人才；'
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '国家自然科学奖、国家技术发明奖、国家科学技术进步奖一等奖获得者（第4、5位完成人）、二等奖获得者（第2至5位完成人）；',
                  '中国专利银奖、优秀奖，中国外观设计银奖前2位完成人（须为专利发明人或设计人）；',
                  '国家重点实验室、国家产业创新中心、国家制造业创新中心、国家技术创新中心、国家工程研究中心副主任（前2名）；',
                  '四川杰出人才奖获得者；',
                  '四川省“天府峨眉计划”“天府青城计划”入选者；',
                  '四川省学术和技术带头人；',
                  '省级青年科技奖获得者；',
                  '省级自然科学奖、技术发明奖、科学技术进步奖一等奖获得者（第1位完成人）；',
                  '省级科学技术杰出贡献奖获得者，省级杰出青年科学技术创新奖获得者；',
                  '省级社会科学优秀成果奖一等奖及以上获得者或项目第1位完成人；',
                  '成都杰出人才奖获得者；',
                  '成都市“蓉漂计划”“蓉城英才计划”入选者；',
                  '相当于上述层次的人才；'
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '省级自然科学奖、技术发明奖、科学技术进步奖一等奖获得者（第2至5位完成人）、二等奖获得者（第1至3位完成人）、三等奖获得者（第1位完成人）。',
                  '相当于上述层次的人才；'
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '商务商业类',
            topBg: require('./../assets/imgs/applyPolicy/sysw.png'),
            policyTips: '在具有健全的财务管理制度和会计核算制度的直管区企业工作，企业达到一定规模能级，对地方经济发展具有一定贡献，或具备丰富专业知识、从业经验的商务管理人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '直管区范围内上年度缴纳税费总额达10亿元及以上经认定的成都市总部企业的主要经营管理者（或团队）。',
                  '直管区范围内上年度营业收入总额达500亿元及以上的批发业企业或营业收入总额达100亿元及以上的零售业企业或缴纳税费总额达到10亿元及以上的批发零售业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）；',
                  '直管区范围内上年度营业收入总额达100亿元及以上或缴纳税费总额达到1亿元及以上的都市工业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）；',
                  '相当于上述层次的人才',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                '直管区范围内上年度缴纳税费总额5亿元（含）至10亿元（不含）经认定的成都市总部企业的主要经营管理者（或团队）。',
                '直管区范围内上年度营业收入总额200亿元（含）至500亿元（不含）的批发业企业或营业收入总额60亿元（含）至100亿元（不含）的零售业企业或缴纳税费总额5亿元（含）至10亿元（不含）的批发零售业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）；',
                '直管区范围内上年度营业收入总额50亿元（含）至100亿元（不含）或缴纳税费总额5000万元（含）至1亿元（不含）的都市工业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）',
                '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '直管区范围内上年度缴纳税费总额1亿元（含）至5亿元（不含）经认定的成都市总部企业的主要经营管理者（或团队）。',
                  '直管区范围内上年度营业收入总额100亿元（含）至200亿元（不含）的批发业企业或营业收入总额20亿元（含）至60亿元（不含）的零售业企业或缴纳税费总额1亿元（含）至5亿元（不含）的批发零售业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）；',
                  '直管区范围内上年度营业收入总额10亿元（含）至50亿元（不含）或缴纳税费总额1000万元（含）至5000万元（不含）的都市工业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）',
                  '企业员工年度工资薪金收入在200万元及以上的人才。（每个单位每年限报5人）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '直管区范围内经认定的成都市总部企业主要经营管理者（或团队）；',
                  '直管区范围内上年度营业收入总额10亿元（含）至100亿元（不含）的批发业企业或营业收入总额10亿元（含）至20亿元（不含）的零售业企业或缴纳税费总额1000万元（含）至1亿元（不含）的批发零售业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）；',
                  '直管区范围内上年度营业收入总额5亿元（含）至10亿元（不含）或缴纳税费总额500万元（含）至1000万元（不含）的都市工业企业的主要经营管理者（或团队）。（营收、税收均可含工商注册、税收登记均在直管区的子公司）',
                  '企业员工年度工资薪金收入在100万元（含）至200万元（不含）的人才。（每个单位每年限报5人）',
                  '相当于上述层次的人才；',

                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '法务类',
            topBg: require('./../assets/imgs/applyPolicy/fw.png'),
            policyTips: '在天府中央法务区的法律行业协会、法律社会组织、法律服务机构、司法鉴定机构从事律师、公证、仲裁、司法鉴定等工作，在相应领域具有领头权威效应和声望，或拥有丰富法务基础知识、从业经验的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国社会科学院学部委员、荣誉学部委员；',
                  '曾任联合国国际法院法官；',
                  '曾任世界贸易组织上诉机构法官；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '全国杰出青年法学家；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '国家认证认可监督管理委员会认定、中国合格评定国家认可委员会实验室认可、国家和省级市场监督管理部门资质认定的司法鉴定机构各专业授权签字人；',
                  '司法部或中华全国律师协会或中国公证协会表彰的全国优秀律师、优秀公证员、优秀司法鉴定人；',
                  '司法部评定的全国千名涉外律师人才；',
                  '国（境）外律师事务所驻四川天府新区代表机构首席代表；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '省级优秀律师、优秀公证员、优秀司法鉴定人；',
                  '副省级城市市场监督管理部门认定的司法鉴定机构各专业授权签字人；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '金融类',
            topBg: require('./../assets/imgs/applyPolicy/jr.png'),
            policyTips: '在直管区范围内的持牌法人金融机构、地方金融机构、投资机构、金融科技企业、金融行业学会（协会）、会计师事务所等企业、机构、组织工作，或拥有丰富金融知识、会计审计从业经验的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国科学院院士，中国工程院院士；',
                  '中国社会科学院学部委员、荣誉学部委员；',
                  '诺贝尔奖（经济学奖）获得者；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '在直管区注册的上年度实际缴纳企业所得税和增值税总额达到20亿元及以上的持牌法人金融机构、地方金融机构的董事长和总经理；',
                  '在直管区注册的上年度实际缴纳企业所得税和增值税总额达到1亿元及以上的基金管理公司董事长，且基金管理公司在管产品规模超过500亿元，基金及在管产品需在中国证券投资基金业协会备案；',
                  '入选美国Vault咨询公司评选的“最佳投资银行Top25（Vault Banking 25）”在直管区注册的实缴资本2亿元及以上的投资机构董事长和总经理，投资机构需入选近3年清科中国创业投资机构年度排行榜或投中中国最佳创业投资机构年度排行榜前10名；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '直管区注册的基金管理公司在管产品规模超过200亿元且在管产品在中国证券投资基金业协会备案的公司董事长；',
                  '直管区注册的持牌法人金融机构或注册资本不低于20亿元的地方金融机构董事长或总经理；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '直管区注册的基金管理公司在管产品规模100亿元（不含）至200亿元（含）且在管产品在中国证券投资基金业协会备案的公司董事长或主要负责人。',
                  '直管区注册的持牌法人金融机构或实缴注册资本不低于5亿元的地方金融机构董事长和总经理；',
                  '直管区注册的上年度实际缴纳企业所得税和增值税总额达到5000万元及以上的持牌法人金融机构、地方金融机构或基金管理公司的高级管理人员，且具有从事私募股权、金融科技、绿色金融、保险精算、投资银行、消费金融、不良资产处置、金融租赁等任一金融专业领域5年及以上工作经验；',
                  '获得特许金融分析师、金融风险管理师、中国精算师、英国精算师、北美精算师、澳洲精算师、特许公认会计师、注册数量金融分析师、全球特许管理会计师、国际金融理财师、美国管理会计师、美国注册会计师、中国注册会计师、加拿大注册会计师、澳大利亚注册会计师、香港注册会计师、国际注册内部审计师、注册国际投资分析师资格证书的人才。（每个单位每年限报10人）；',
                  '已认定为成都市重大或高能级项目的持牌法人金融机构省级分公司主要负责人；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '教育体育类',
            topBg: require('./../assets/imgs/applyPolicy/jyty.png'),
            policyTips: '在直管区的高校、中小学校、幼儿园、教育类事业单位从事一线教育教学工作，为人师表、师德高尚，所在教学层次或教学学科具有领头权威效应和声望，或拥有丰富教育基础知识、从业经验的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国科学院院士，中国工程院院士；',
                  '中国社会科学院学部委员、荣誉学部委员；',
                  '劳伦斯奖获得者；',
                  '共和国勋章、“七一”勋章、“八一”勋章等党和国家、军队最高荣誉勋章获得者，且受聘于直管区教师共享平台开展国防教育工作的人才；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '“长江学者奖励计划”特聘教授、青年学者；',
                  '全国教书育人楷模、全国模范教师；',
                  '奥运会金牌获得者，列入奥运会项目的世界杯、世锦赛金牌获得者（含运动员及总教练、主教练），且受聘于直管区教师共享平台并服务直管区教育体育事业的人才；',
                  '中央军委授予的个人荣誉称号获得者，国家安全委员会成员、中国发展战略学研究会专家委员，且受聘于直管区教师共享平台主持国防教育政策制定、课程建设、教育教学等工作的人才；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '四川省特级教师（校长）、四川省中小学名校长；',
                  '基础教育国家级优秀教学成果奖一等奖及以上奖项成果完成人（第1位完成人）；',
                  '四川省基础教育教学成果奖特等奖成果完成人（第1位完成人）；',
                  '“天府新区教育发展特别奖”“天府新区首席校长”获得者；',
                  '奥运会银牌、铜牌获得者，列入奥运会项目的世界杯、世锦赛银牌、铜牌获得者，亚运会、全运会、大运会金牌获得者（含运动员及总教练、主教练），且受聘于直管区教师共享平台并服务直管区教育体育事业的人才；',
                  '个人一等功或二等战功及以上获得者（每年限报1人），军队院校育才金奖获得者，中宣部国防和军事领域外宣专家组成员，且受聘于直管区教师共享平台参与国防教育政策制定、课程建设、活动策划以及组织开展国防教育活动等工作的人才；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '基础教育国家级优秀教学成果奖二等奖成果完成人（第1位完成人）；',
                  '四川省基础教育教学成果奖一、二等奖成果完成人（第1位完成人）；',
                  '省级及以上优秀教师、教书育人名师、中小学名班主任，副省级城市及以上特级教师（校长）、优秀青年教师、学科带头人、优秀班主任；',
                  '亚锦赛金牌获得者，亚运会、全运会、大运会银牌、铜牌获得者（含运动员及总教练、主教练），且受聘于直管区教师共享平台并服务直管区教育体育事业的人才；',
                  '受聘于直管区教师共享平台，长期在直管区工作的国家级及以上裁判员；',
                  '受聘于直管区教师共享平台，为直管区直接培养出全国青运会、四川省运动会（青少年组）冠军获得者的主教练；',
                  '个人二等功或三等战功及以上获得者（每年限报1人），军队院校育才银奖获得者，且受聘于直管区教师共享平台从事国防教育工作两年以上的人才；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '医疗卫生类',
            topBg: require('./../assets/imgs/applyPolicy/ylws.png'),
            policyTips: '在直管区的医疗卫生机构从事一线医疗卫生工作，医德高尚、医术精湛，所管理机构、负责单元或领衔项目在行业相应层次具有权威效应或声望的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国科学院院士，中国工程院院士；',
                  '诺贝尔奖（生理学或医学奖）获得者；',
                  '专业技术一级岗位人才（卫生、中医药类）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '国家卫生健康突出贡献中青年专家；',
                  '国医大师、全国名中医；',
                  '南丁格尔奖、吴阶平医学奖、何梁何利基金科学与技术成就奖、白求恩奖、中华医学科技奖获得者；',
                  '医疗卫生国家级专委会主任委员、国家级协会会长；',
                  '国家级临床重点专科带头人；',
                  '部级临床医学研究中心主任；',
                  '复旦大学医院管理研究所《中国医院专科排行榜》最近排名前10位医院科室主要负责人；',
                  '《中国医院综合排行榜》最近排名前100位医院的主要负责人；',
                  '专业技术二级岗位人才（卫生、中医药类）；',
                  '．相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '中国医师奖获得者；',
                  '四川省卫生健康首席专家；',
                  '副省级及以上十大名（中）医（工作室冠名专家）；',
                  '担任医疗卫生国家级专委会副主任委员、常务委员或国家级协会副会长；省级专委会主任委员；',
                  '省级临床重点专科带头人或临床医学研究中心主任；',
                  '国家卫健委全国性技能竞赛一等奖（或第一名）获得者，国家卫健委技术能手；',
                  '国家自然科学基金资助的医学方面科研课题第一负责人；',
                  '专业技术三级岗位人才（卫生、中医药类）；',
                  '近5年，中国医院管理奖得奖案例主要负责人或主要贡献者；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '四川省卫生健康委员会学术技术带头人；',
                  '担任医疗卫生国家级专委会委员、省级专委会副主任委员职务；',
                  '四川省卫生健康领军人才、四川省临床技能名师、四川省基层卫生拔尖人才；',
                  '省级卫健委举办的全省性技能竞赛一等奖（或第一名）获得者或被省级卫健委评为技术能手；',
                  '副省级城市市本级临床重点专科带头人或临床医学研究中心主任；',
                  '作为主要成员（前2名）承担过省部级及以上研究课题并结题或成果获省部级及以上奖励的人才；',
                  '专业技术四级岗位人才（卫生、中医药类）；',
                  '获省级及以上卫生健康部门评定的“基层临床特色科室”主要负责人或主要贡献者；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '文旅会展类',
            topBg: require('./../assets/imgs/applyPolicy/wlhz.png'),
            policyTips: '坚持正确政治方向，在直管区从事哲学、社会科学、新闻出版、网络视听、文化艺术、创意设计、数字版权、文博事业、文化产业、国际文化交流合作、会展博览等相关领域工作，取得成效得到相应层次行业权威认定，或拥有丰富宣传文化基础知识、从业经验，在文创会展产业建圈强链中具有引领带动作用的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国社会科学院学部委员、荣誉学部委员；',
                  '诺贝尔奖（文学奖）获得者；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '奥斯卡金像奖、柏林国际电影节奖获得者；',
                  '全国文化名家暨“四个一批”人才；',
                  '中国政府“友谊奖”获得者；',
                  '国家级非物质文化遗产代表性传承人；',
                  '茅盾文学奖获得者，鲁迅文学奖获得者；',
                  '担任全球展览业协会（UFI）、国际大会及会议协会（ICCA）委员及以上职务的人员；',
                  '国家级文化产业示范园区、国家级文化产业示范基地、国家旅游度假区、国家AAAAA级旅游景区（项目）的运营机构高级管理人员。（每个单位限报1人）；',
                  '中国版权金奖作品获得者（第1位完成人）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '中宣部精神文明建设“五个一工程”奖获奖作品第1位主创人员；',
                  '全国中青年德艺双馨文艺工作者；',
                  '中宣部宣传思想文化青年英才入选者；',
                  '长江韬奋奖获得者；',
                  '省级非物质文化遗产代表性传承人；',
                  '中国电影华表奖、电视剧飞天奖获得者（第1位完成人）；',
                  '中国文化艺术政府奖文华奖获得者（第1位完成人）；',
                  '中国戏剧梅花奖、音乐金钟奖、曲艺牡丹奖、书法兰亭奖金奖、杂技金菊奖、摄影金像奖、民间文艺山花奖、电视金鹰奖、全国优秀儿童文学奖获得者，舞蹈荷花奖单项奖获得者或作品奖第1位主创人员；',
                  '中国新闻奖特别奖、一等奖获得者；中国广播电视大奖、金声奖获得者（含原“金话筒奖”）；',
                  '中国文化艺术政府奖动漫奖获得者、中国科幻银河奖获得者；',
                  '“金熊猫奖”获得者；',
                  '四川省“天府友谊奖”获得者；',
                  '成都市“金沙友谊奖”获得者；',
                  '省级文化产业示范园区、省级文化产业示范基地、省级领军型文化企业运营机构的高级管理人员。落地直管区全球30强会展企业、全国文化企业30强，文旅类上市企业、独角兽企业的二级公司、地区总部法定代表人或主要经营管理者。（最近年度由德国展览业协会AUMA评选的“全球30强会展企业”，近5年由中央文化体制改革和发展工作领导小组办公室组织推荐认定评选的“全国文化企业30强”，每个单位限报1人）；',
                  '获得私募股权投资5亿元及以上的文创团队带头人或核心成员。（每个单位限报1人）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '省级精神文明建设“五个一工程”奖获奖作品第1位主创人员；',
                  '成都市非物质文化遗产代表性传承人；',
                  '获得“中国青年导演扶持计划”支持的青年导演；',
                  '在直管区专业会展场馆举办面积超3万平方米的省级及以上展览，参会人数1000人以上的国家级或国际性或专业型会议项目的主要负责人。（每个申报项目限申报1次且1人）；',
                  '全国三维数字化创新设计大赛、全国大学生先进成图技术与产品信息建模创新大赛、中国软件杯大赛奖项获得者；',
                  '爱奇艺、腾讯、优酷、芒果TV、哔哩哔哩S级以上影视作品第一出品人、第一导演、第一编剧，播放量超1千万的有声书、广播剧的主要配音演员（男女主角），抖音、快手年度TOP20短视频创作博主；',
                  '阅文集团、抖音有限公司旗下小说平台阅读总排行榜前50作品的第一创作者；',
                  '直管区注册MCN机构独家签约的年带货销售额1亿元以上头部主播；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '农业农村类',
            topBg: require('./../assets/imgs/applyPolicy/nync.png'),
            policyTips: '长期服务直管区乡村振兴工作，熟悉乡村规划建设、农业经济管理、农村种养殖、农业科技发展、农田保护与利用、土壤改良、农业对外投资与合作交流、农业生态建设管理、新农村建设及农村人居环境、农业品牌建设和农产品质量安全监督管理、农村产权制度改革、农田水利建设、水系规划、水环境治理、水工程建设和统筹城乡等专业知识，取得成效得到相应层次行业权威认可，或拥有丰富农业农村基础知识、从业经验的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国科学院院士，中国工程院院士；',
                  '世界农业奖获得者；',
                  '世界粮食奖获得者；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '国家现代农业产业技术体系首席科学家；',
                  '全国农牧渔业丰收奖“农业技术推广贡献奖”获得者、“农业技术推广成果奖”一等奖主要完成人（前3位完成人）、“农业技术推广合作奖”主要完成人（第1位完成人）；',
                  '神农中华农业科技奖科学研究类成果一等奖主要完成人（前3位完成人）、科学普及奖主要完成人（第1位完成人）、优秀创新团队奖主要完成人（第1位完成人）；',
                  '农业科研杰出人才；',
                  '中华农业英才奖获得者；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '国家现代农业产业技术体系岗位科学家；',
                  '“神农英才”计划神农领军英才入选者、神农青年英才入选者；',
                  '全国十佳农民；',
                  '全国农牧渔业丰收奖“农业技术推广成果奖”二等奖主要完成人（前3位完成人）、“农业技术推广合作奖”主要完成人（第2位完成人）；',
                  '神农中华农业科技奖科学研究成果奖二等奖主要完成人（前3位完成人）、科学普及奖主要完成人（第2位完成人）、优秀创新团队奖主要完成人（第2位完成人）；',
                  '“大国农匠”全国农民技能大赛一等奖获得者；',
                  '杰出青年农业科学家；',
                  '中国农学会青年科技奖获得者；',
                  '全国农村青年致富带头人标兵；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '全国农牧渔业丰收奖“农业技术推广成果奖”三等奖主要完成人（前3位完成人）、“农业技术推广合作奖”主要完成人（第3位完成人）；',
                  '神农中华农业科技奖科学研究成果奖三等奖主要完成人（前3位完成人）、科学普及奖主要完成人（第3位完成人）、优秀创新团队奖主要完成人（第3位完成人）；',
                  '“大国农匠”全国农民技能大赛二等奖、三等奖获得者；',
                  '成都市“十佳”农业职业经理人；',
                  '神内基金农技推广奖获得者；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '技术技能类',
            topBg: require('./../assets/imgs/applyPolicy/jsjn.png'),
            policyTips: '长期在直管区工业企业工作，所在企业达到一定规模，或掌握技艺技能，乐于带徒传技、传授经验、技能推广，取得成效得到相应层次行业权威认可，或拥有丰富技能基础知识、从业经验的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国科学院院士，中国工程院院士；',
                  '世界技能大赛金牌获得者；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '世界技能大赛银牌获得者；',
                  '中国工艺美术大师；',
                  '全国杰出专业技术人才；',
                  '中华技能大奖获得者；',
                  '大国工匠；',
                  '主创作品获得中国设计红星奖、德国红点奖、德国iF设计奖、日本G-Mark设计奖、美国Idea国际设计优秀奖等同级别国际设计大奖的个人或公司设计团队负责人；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '世界技能大赛铜牌获得者；',
                  '省级工艺美术大师；',
                  '全国技术能手；',
                  '国家级技能大师工作室领衔人；',
                  '全国专业社会工作领军人才；',
                  '四川工匠；',
                  '直管区范围内国家单项冠军示范企业、国家专精特新“小巨人”企业的技术负责人。（每个单位限报1人）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '成都市工艺美术大师；',
                  '省级技能大师工作室领衔人；',
                  '成都市技能大师工作室及首席技师工作室领衔人；',
                  '成都工匠；',
                  '具有正高级专业技术职务任职资格的专业技术人才；',
                  '高级社会工作师职业资格证书获得者；',
                  '具有高级技师职业资格，并取得以下成果之一的技能人才：副省级城市或省会城市的市级技术能手、技能大师工作室领衔人、工匠、工艺美术大师、非物质文化遗产代表性传承人；',
                  '直管区范围内国家高新技术企业、省级“专精特新”企业的技术负责人。（每个单位限报1人）；',
                  '直管区范围内上年度新入库规模以上工业企业的主要经营管理人才。（每个单位限报1人）；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '城市建设类',
            topBg: require('./../assets/imgs/applyPolicy/csjs.png'),
            policyTips: '围绕直管区公园城市首提地建设，在直管区从事城市规划、建筑设计、景观设计、勘察、施工等方面工作，能将设计理念、设计服务全面融入直管区空间环境、城市品牌，取得成效得到相应层次行业权威认可，或拥有丰富城市建设基础知识、从业经验的人才，按照行业认可标准，分别给予A、B、C、D四个层次政策支持。',
            policyType: [
              {
                policyTypeTip: 'A',
                policyTypeTitle: 'A类人才',
                policyTypeList: [
                  '中国科学院院士，中国工程院院士；',
                  '普利兹克奖获得者；',
                  '直管区范围内上年度营业收入总额达到1000亿元及以上或缴纳税费总额达到75亿及以上房地产企业的主要经营管理者（或团队）。（含直管区范围内所有项目公司营收；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'B',
                policyTypeTitle: 'B类人才',
                policyTypeAsk: '年龄原则上60岁以下',
                policyTypeList: [
                  '金块奖、国际建筑奖、阿卡汗建筑奖、亚洲建筑师协会建筑奖获得者；',
                  '梁思成建筑奖获得者、全国工程勘察设计大师；',
                  '中国土木工程詹天佑奖获奖工程项目主要负责人；',
                  '华夏建设科学技术奖特等奖、一等奖获得者（第1位完成人）；',
                  '直管区范围内上年度营业收入总额达到500亿元及以上或缴纳税费总额达到45亿及以上房地产企业的主要经营管理者（或团队）。（含直管区范围内所有项目公司营收）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'C',
                policyTypeTitle: 'C类人才',
                policyTypeAsk: '年龄原则上55岁以下',
                policyTypeList: [
                  '中国建设工程鲁班奖（国家优质工程）、国家优质工程奖金奖、中国建筑工程钢结构金奖项目主要负责人；',
                  '全国优秀工程勘察设计奖金质奖、中国勘察设计协会行业优秀勘测设计奖一等奖项目主要参加人员（前3位完成人）；',
                  '全国绿色建筑创新奖一等奖项目主要完成人（前3位完成人）；',
                  '华夏建设科学技术奖二等奖获得者（第1位完成人）；',
                  '直管区范围内上年度营业收入总额达到100亿元及以上或缴纳税费总额达到10亿及以上房地产企业的主要经营管理者（或团队）。（含直管区范围内所有项目公司营收）；',
                  '相当于上述层次的人才；',
                ]
              },
              {
                policyTypeTip: 'D',
                policyTypeTitle: 'D类人才',
                policyTypeAsk: '年龄原则上45岁以下',
                policyTypeList: [
                  '全国优秀工程勘察设计奖银质奖、中国勘察设计协会行业优秀勘测设计奖二等奖项目主要参加人员（前3位完成人）；',
                  '全国绿色建筑创新奖二等奖项目主要完成人（前3位完成人）；',
                  '华夏建设科学技术奖三等奖获得者（第1位完成人）；',
                  '中国安装工程优质奖（中国安装之星）项目主要负责人；',
                  '四川省建设工程天府杯奖（省优质工程）、四川省结构优质工程奖、四川省安装工程优质奖（蜀安杯）、四川省优质钢结构工程奖（蜀钢杯）项目主要负责人；',
                  '具有一级注册建筑师、一级注册结构工程师、一级注册建造师、一级注册造价师、注册城乡规划师、注册土木工程师、注册公用设备工程师、注册电气工程师、注册监理工程师、注册岩土工程师、一级注册消防工程师、高级注册安全工程师证书的人才。（每个单位每年限报10人）；',
                  '直管区范围内上年度营业收入总额达到20亿元及以上或缴纳税费总额达到3亿及以上房地产企业的主要经营管理者（或团队）。（含直管区范围内所有项目公司营收）；',
                  '相当于上述层次的人才；',
                ]
              }
            ],
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            conditionList: [
              {
                title: '申请非柔性人才',
                items: [
                '（1）人才应全职在直管区工作 ',
                '（2）与用人单位签订连续不少于3年的劳动合同；',
                '（3）申请时在直管区实际工作时间不少于9个月。'
                ]
              },
              {
              title: '申请柔性人才',
              items: [
                '（1）符合B类及以上层次人才标准；',
                '（2）每年在直管区实际工作时间在3个月（含）以上9个月以下的人才。'
                ]
              }
            ],
            policyContentTitle: '根据《四川天府新区直管区人才支持政策》',
            policyContent: [
              'A类人才资助金额由人才工作领导小组“一事一议”研究确定，原则上不低于成都市A类人才资助标准，以及配备人才住房，享受配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'B类人才可享受200万元资助，以及配偶就业、人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'C类人才可享受50万元资助，以及人才落户、人才安居、医疗保障、交通服务、健康疗养、“天府新区英才卡”等各项配套政策中所对应的服务保障；',
              'D类人才可享受10万元资助，以及人才落户、人才安居、“天府新区英才卡”等各项配套政策中所对应的服务保障。'
            ],
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '顶尖团队',
            topBg: require('./../assets/imgs/applyPolicy/djtd.png'),
            policyTips: 'A类人才或相同层次人才为带头人的团队开展重大产业化项目。',
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            policyContent: '经评审认定，按照“先投后股”方式，按8000万元、5000万元、3000万元、1000万元四个档次给予资助，特别优秀的给予1亿元支持额度。相关支持额度5年内按约定比例分批拨付到团队所在企业。',
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '高级团队',
            topBg: require('./../assets/imgs/applyPolicy/gjtd.png'),
            policyTips: 'C类及以上层次人才为带头人的团队开展产业化项目（带头人股权不低于30%），团队核心成员中应有不少于3人省级及以上高层次人才。',
            conditionTips: '人才认定须依托直管区所在用人单位申报，其单位注册地和税收解缴关系须在直管区，且为直管区做出实际贡献。',
            policyContent: '经评审认定，按照“先投后股”方式，按500万元、300万元、200万元三个档次给予资助，相关支持额度3年内按约定比例分批拨付到团队所在企业。',
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '杰出贡献奖',
            topBg: require('./../assets/imgs/applyPolicy/jiechu.png'),
            policyTips: '对直管区经济社会发展做出杰出贡献且获得认可的人才，可申请该奖项，经人才工作领导小组研究给予奖励。',
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          },
          {
            pageTitle: '伯乐奖',
            topBg: require('./../assets/imgs/applyPolicy/bole.png'),
            policyTips: '为直管区人才引进工作做出突出贡献且获得认可的个人或机构，可申请该奖项，经人才工作领导小组研究给予奖励。',
            applyPath: '符合条件的人才可自行登陆四川天府新区智慧人才服务平台(https://www.tfxqtalents.com:8001/web)进行申请。',
            applyTime: '全年',
            tel: '028-68773465',
            company: '中共四川天府新区工作委员会党群工作部'
          }
        ],
        policyObj: {}
      };
  },

  components: {
      call,
  },
  created() {
    const id = +this.$route.params.id
    this.id = id
    this.policyObj = this.policyList[id]
    document.title = this.policyObj.pageTitle
  },
  mounted() {},

  methods: {
    // 跳转官网
    navWeb() {
      window.open('https://www.tfxqtalents.com:8001/web', '_blank')
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
      width: 7.26rem;
      height: 5.64rem;
  }

  .technological-process {
      transform: translateY(-2.2rem);

      .sxcl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #fff;
              margin: -0.45rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;
              line-height: 0.44rem;

          }
          .policy-content-title {
            width: 6.85rem;
            background-color: #D4E0FF;
            margin: 0 auto;
            margin-top: -0.28rem;
            display: flex;
            align-items: center;
            color: #4E4E4E;
            font-weight: bold;
            font-size: 0.26rem;
            padding-left: 0.55rem;
            box-sizing: border-box;
            .policy-content-title-tip {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 50%;
              border: 0.03rem solid #FF6D60;
              box-sizing: border-box;
              margin-right: 0.1rem;
            }
          }
          .policy-content-box {
            width: 6.85rem;
            margin: 0 auto;
            background-color: #D4E0FF;
            padding: 0rem 0.33rem;
            padding-top: 0.22rem;
            margin-top: -0.02rem;
            box-sizing: border-box;
            .policy-content {
              width: 100%;
              margin-top: 0.22rem;
              border-radius: 0.2rem;
            }
            .policy-content:first-child {
              margin-top: 0;
            }
            .policy-content-leader {
              font-size: 0.26rem;
              color: #0839B7;
              font-weight: 500;
              text-align: left;
              padding-top: 0.18rem;
              padding-bottom: 0.35rem;
            }
          }
      }

      .zccl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.75rem auto 0;
              padding: 0.33rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 2;

              .cricle-tip {
                display: inline-block;
                width: 0.2rem;
                height: 0.2rem;
                border-radius: 50%;
                border: 0.03rem solid #FF6D60;
                box-sizing: border-box;
              }

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0rem 0.23rem 0.3rem 0;
                  margin-top: 0.22rem;
                  position: relative;
                  .persona-bility-title {
                    width: 1.67rem;
                    height: 0.6rem;
                    background-color: #739BFE;
                    border-radius: 0.2rem 0 0 0;
                    padding: 0.11rem 0 0.11rem 0.12rem;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    font-size: 0.24rem;
                    font-weight: bold;
                    color: #fff;
                    margin-bottom: 0.13rem;
                    line-height: 2;
                    & > div:first-child {
                      width: 0.36rem;
                      height: 0.36rem;
                      background-color: #fff;
                      border-radius: 0.25rem 0 0 0;
                      margin-right: 0.12rem;
                      color: #739BFE;
                      text-align: center;
                      line-height: 0.36rem;
                    }
                  }
                  .policyTypeAsk {
                    margin-top: 0.13rem;
                    font-size: 0.26rem;
                    color: #DB2323;
                    font-weight: 500;
                    padding-left: 0.29rem;
                    font-weight: 500;
                    margin-bottom: 0.08rem;
                  }

                  .part {

                      // border-bottom: 0.01rem solid #3d5aa3;
                      .title {
                          font-size: 0.28rem;
                          font-weight: bold;
                          color: #0839b7;
                      }

                      .sub-title {
                          margin-top: 0.17rem;
                          font-size: 0.26rem;
                          font-weight: bold;
                      }

                      .contents {
                          margin-top: 0.2rem;
                          margin-bottom: 0.3rem;
                      }

                      .line {
                          width: 100%;
                          height: 0.01rem;
                          background-color: #3d5aa3;
                          opacity: 0.5;
                          margin-bottom: 0.2rem;
                      }
                  }
              }
              .condition-box {
                width: 6.2rem;
                background-color: #fff;
                padding: 0.62rem 0.21rem 0.28rem 0.21rem;
                border-radius: 0.2rem;
                margin-top: 0.67rem;
                box-sizing: border-box;
                .condition-title {
                  width: 2.98rem;
                  height: 0.67rem;
                  background-color: #739BFE;
                  border-radius: 1rem;
                  color: #fff;
                  font-weight: bold;
                  text-align: center;
                  line-height: 0.67rem;
                  margin: 0 auto;
                  margin-top: -0.96rem;
                  margin-bottom: 0.23rem;
                }
                .condition-item {
                  text-align: left;
                  margin-top: 0.1rem;
                  font-size: 0.26rem;
                  color: #4E4E4E;
                }
              }
          }
      }

      .sbcl {
          position: relative;
          margin-top: 0.22rem;

          .top {
              width: 7.03rem;
              height: 1.37rem;
              margin-left: -0.18rem;
          }

          .content {
              width: 6.85rem;
              background: #e8eeff;
              margin: -0.45rem auto 0;
              padding: 0 0.33rem 0.64rem 0.36rem;
              box-sizing: border-box;
              border-radius: 0rem 0rem 0.26rem 0.26rem;
              padding-top: 0.28rem;
              font-size: 0.26rem;
              font-weight: 500;
              text-align: left;
              color: #4e4e4e;

              .des {
                  color: #4e4e4e;
                  text-align: left;
                  background: #ffffff;
                  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                  padding: 0.35rem 0.23rem 0.3rem;
                  margin-top: 0.22rem;
                  position: relative;

                  .item {
                      margin-top: 0.35rem;
                      box-sizing: border-box;
                      position: relative;
                      padding-left: 0.42rem;

                      // display: flex;
                      .line {
                          position: absolute;
                          width: 0.02rem;
                          height: 135%;
                          border-left: 0.02rem dashed #739bfe;
                          left: 0.1rem;
                          top: 0.2rem;
                          z-index: 0;
                          //   background-color: #739bfe;
                      }

                      .dot {
                          width: 0.39rem;
                          height: 0.39rem;
                          background-color: #739bfe;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          font-size: 0.28rem;
                          color: #fff;
                          border-radius: 50%;
                          position: absolute;
                          left: -0.1rem;
                          top: 0;
                          z-index: 9999;
                      }

                      .label {
                          font-size: 0.26rem;
                          font-weight: bold;
                      }
                  }
              }
          }
      }

      .codes {
          margin: 0 auto;
          margin-top: 0.25rem;
          width: 6.85rem;
          background: #fff;
          padding: 0.3rem;
          box-sizing: border-box;
          border-radius: 0.26rem;
          padding-top: 0.28rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .code {
              width: 1.94rem;
              height: 1.94rem;
          }

          .text {
              width: 4.3rem;
          }
      }
  }
  .contact {
    a {
      font-weight: 500;
      color: #2078ff;
    }
  }
}
</style>
